module.exports = __webpack_public_path__ + "static/media/wuerttembergische_logo.63b3a9f7.png";